import React, { useRef, useState } from "react";
import "./AddProduct.scss";
import { ReactTabulator } from "react-tabulator";
// import SearchableSelect from "./SearchableSelect";
import { toast } from "react-toastify";
import SelectOptionSearch from "../UI/SelectOptionSearch";
import { set } from "react-hook-form";
import ObjectDataHolder from "../../Components/Hooks/ObjectDataHolder";

const AddProduct = () => {
  const tableRefKPI = useRef(null); //fetch fields table
  const [tabulatorDataState, setTabulatorDataState] = useState([]); //General data of the fetch fileds table
  const [selectedRow, setSelectedRow] = useState();
  const [rowData, setRowData] = ObjectDataHolder({
    // title: "",
    productMode: "",
    materialMode: "",
    productCode: "",
    productName: "",
    materialName: "",
    materialCode: "",
    amount: "",
  });

  const optionsName = [
    { value: "تیشرت", label: "تیشرت", code: "021" },
    { value: "شلوار", label: "شلوار", code: "0255" },
    { value: "شال", label: "شال", code: "356" },
  ];

  const optionsCode = [
    { value: "021", label: "021", name: "تیشرت" },
    { value: "0255", label: "0255", name: "شلوار" },
    { value: "356", label: "356", name: "شال" },
  ];

  const materialsName = [
    { value: "نخ", label: "نخ", code: "236" },
    { value: "پنبه", label: "پنبه", code: "237" },
    { value: "ابریشم", label: "ابریشم", code: "2323" },
  ];

  const materialsCode = [
    { value: "236", label: "021", name: "نخ" },
    { value: "237", label: "0255", name: "پنبه" },
    { value: "2323", label: "356", name: "ابریشم" },
  ];

  // delete a row from table
  const deleteRowHandler = (tableArray, rowId) => {
    debugger;
    const table = [...tableArray];
    let newDataTable = table.filter((row) => row.id !== rowId);
    return newDataTable;
  };

  function rowClickHandler(e, row) {
    row.getTable().getSelectedRows().length === 0
      ? setSelectedRow()
      : setSelectedRow(row);
  }

  //  اضافه شدن دیتا به جدول
  const addRowPlease = (e) => {
    debugger;
    e.preventDefault();
    if (rowData.materialName === "") {
      toast.error("نام ماده را انتخاب کنید");
      return;
    }
    if (rowData.materialCode === "") {
      toast.error("کد ماده را انتخاب کنید");
      return;
    }
    if (rowData.amount === "") {
      toast.error("مقدار را وارد کنید");
      return;
    }
    let tempDataTabulator = [];

    //General data of the Fetch fields table
    let tableDataPlease = tableRefKPI.current.table.getData();

    let objectToAdd = {
      id: `Row${Math.random()}`,
      materialNameField: rowData.materialName,
      materialCodeField: rowData.materialCode,
      valueField: rowData.amount,
    };

    if (tableDataPlease.length > 0) {
      debugger;
      tableDataPlease.forEach((v) => {
        const tempO = { ...objectToAdd };
        delete tempO.id;
        const tempV = { ...v };
        delete tempV.id;
        //If it was a duplicate, can you please not allow it to be added to the table?
        if (
          JSON.stringify(tempV.materialNameField) ===
          JSON.stringify(tempO.materialNameField)
        ) {
          toast.error("این مورد قبلا به جدول اضافه شده است.");
          return;
        }
        if (
          JSON.stringify(tempV.materialCodeField) ===
          JSON.stringify(tempO.materialCodeField)
        ) {
          toast.error("این مورد قبلا به جدول اضافه شده است.");
          return;
        }
        tempDataTabulator.push({
          id: v.id,
          materialNameField: v.materialNameField,
          materialCodeField: v.materialCodeField,
          valueField: v.valueField,
        });
      });
      tempDataTabulator.push(objectToAdd);
    } else {
      tempDataTabulator.push(objectToAdd);
    }
    console.log(tempDataTabulator);
    setTabulatorDataState(tempDataTabulator);
  };

  //send data for back
  const sendDataForBackend = (e) => {
    debugger;
    e.preventDefault();
    if (rowData.productName === "") {
      toast.error("نام محصول را انتخاب کنید");
      return;
    }
    if (rowData.productCode === "") {
      toast.error("کد محصول را انتخاب کنید");
      return;
    }

    //General data of the Fetch fields table
    let tableDataPlease = tableRefKPI.current.table.getData();
    if (tableDataPlease.length === 0) {
      toast.error("موردی در جدول ثبت نشده است");
      return;
    }

    const sendData = {
      productName: rowData.productName,
      productCode: rowData.productCode,
      details: tableDataPlease,
    };
    console.log(sendData);
    toast.success("اطلاعات با موفقیت ثبت شد.");
    setTimeout(() => {
      setRowData({
        productMode: "",
        materialMode: "",
        productCode: "",
        productName: "",
        materialName: "",
        materialCode: "",
        amount: "",
      });
      setTabulatorDataState([]);
    }, 2000);
  };

  const tableOptions = { layout: "fitDataTable", selectable: 1 };

  const tableColumns = [
    {
      title: "ماده خام",
      field: "materialNameField",
    },
    {
      title: "کد ماده خام",
      field: "materialCodeField",
      visible: false,
    },
    {
      title: "مقدار",
      field: "valueField",
    },
    {
      title: "عملیات",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      maxWidth: 80,
      headerHozAlign: "center",
      cellClick: function (e, cell) {
        const table = tableRefKPI.current.table;
        const rowId = cell.getData().id;
        const tableData = deleteRowHandler(tabulatorDataState, rowId, table);
        setTabulatorDataState(tableData);
      },
    },
  ];

  return (
    <div className="addProductContainer__">
      <form className="form__">
        {/* <div className="input__group">
          <label>عنوان</label>
          <input
            value={rowData.title}
            onChange={(e) => {
              setRowData({ title: e.target.value });
            }}
            type="text"
            placeholder="عنوان مورد نظر خود را وارد کنید"
            id={"titleForAddProduct"}
          />
        </div> */}
        <div className="flex_group_">
          <div className="select__group">
            <label>انتخاب محصول</label>
            <select
              value={rowData.productMode}
              id={"refNumber1"}
              onChange={(e) => {
                setRowData({ productMode: e.target.value });
              }}
            >
              <option value="" hidden>
                انتخاب کنید
              </option>
              <option value={"name"}>براساس نام محصول</option>
              <option value={"code"}>بر اساس کد محصول</option>
            </select>
          </div>
          {rowData.productMode === "name" && (
            <div className="selectOptionPrnt__">
              <label>نام محصول</label>
              <SelectOptionSearch
                classNameInput={"selectSearchInput__"}
                options={optionsName}
                onSelect={(event, inputText) => {
                  setRowData({
                    productName: inputText.value,
                    productCode: inputText.code,
                  });
                }}
                defaultValue={rowData.productName}
              />
            </div>
          )}
          {rowData.productMode === "code" && (
            <div className="selectOptionPrnt__">
              <label>کد محصول</label>
              <SelectOptionSearch
                classNameInput={"selectSearchInput__"}
                options={optionsCode}
                value={rowData.productCode}
                onSelect={(event, inputText) => {
                  debugger;
                  setRowData({
                    productCode: inputText.value,
                    productName: inputText.name,
                  });
                }}
                defaultValue={rowData.productCode}
              />
            </div>
          )}
        </div>
        <div className="line__"></div>
        <div className="flex_group_">
          <div className="select__group">
            <label>انتخاب ماده</label>
            <select
              id={"refNumber3"}
              value={rowData.materialMode}
              onChange={(e) => {
                setRowData({ materialMode: e.target.value });
              }}
            >
              <option value="" hidden>
                انتخاب کنید
              </option>
              <option value={"matName"}>براساس نام ماده</option>
              <option value={"matCode"}>براساس کد ماده</option>
            </select>
          </div>
          {rowData.materialMode === "matName" && (
            <div className="selectOptionPrnt__">
              <label>نام ماده</label>
              <SelectOptionSearch
                classNameInput={"selectSearchInput__"}
                options={materialsName}
                onSelect={(event, inputText) => {
                  setRowData({
                    materialName: inputText.value,
                    materialCode: inputText.code,
                  });
                }}
                defaultValue={rowData.materialName}
              />
            </div>
          )}
          {rowData.materialMode === "matCode" && (
            <div className="selectOptionPrnt__">
              <label>کد ماده</label>
              <SelectOptionSearch
                classNameInput={"selectSearchInput__"}
                options={materialsCode}
                onSelect={(event, inputText) => {
                  setRowData({
                    materialCode: inputText.value,
                    materialName: inputText.name,
                  });
                }}
                defaultValue={rowData.materialCode}
              />
            </div>
          )}
        </div>
        <div className="input__group half_width">
          <label>مقدار</label>
          <input
            type={"number"}
            placeholder="اطلاعات خود را وارد کنید"
            value={rowData.amount}
            onChange={(e) => {
              setRowData({ amount: e.target.value });
            }}
          />
        </div>
        <div className="btn__parent">
          <button onClick={addRowPlease}>افزودن</button>
        </div>
        <div className="table_holder">
          <ReactTabulator
            ref={tableRefKPI}
            columns={tableColumns}
            data={tabulatorDataState}
            options={tableOptions}
            style={{ height: "30vh" }}
            events={{ rowClick: rowClickHandler }}
          />
        </div>
        <div className="btn__parent">
          <button onClick={sendDataForBackend}>ثبت نهایی</button>
        </div>
      </form>
    </div>
  );
};

export default AddProduct;
